import React, { useState } from "react";
import noImg from "../../../assets/images/no-img.png";

const TableProfile = ({ image }) => {
  const [preview, setPreview] = useState(false);

  return (
    <>
      <div className="table_img" style={{ cursor: "pointer" }}>
        <img
          src={image || noImg}
          alt=""
          className="img-fluid"
          onClick={() => setPreview(true)}
        />
      </div>

      {preview && (
        <div
          className="preview-overlay"
          onClick={() => setPreview(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.8)",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={image || noImg}
              alt="preview"
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                borderRadius: "10px",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default TableProfile;
